import React from 'react'
import { connect } from 'react-redux'
import { updateDistanceOnIntervalAction, clearUpdateDistanceIntervalAction } from 'actions/calculatorActions'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class PpfPreviewControls extends React.Component {
  state = { updatingDistance: false }

  componentDidMount = _ => {
    document.onmouseup = this.stopUpdatingDistance
  }

  componentWillUnmount = _ => {
    document.onmouseup = null
  }

  startUpdateDistanceSaga = increasing => {
    const { updateDistanceOnIntervalAction, currentCamera: { id } } = this.props
    updateDistanceOnIntervalAction(increasing, id)
    this.setState({ updatingDistance: true })
  }

  stopUpdatingDistance = _ => {
    const { state: { updatingDistance }, props: { clearUpdateDistanceIntervalAction } } = this
    if (updatingDistance) {
      clearUpdateDistanceIntervalAction()
      this.setState({ updatingDistance: false })
    }
  }

  render() {
    const { distance, ppf, isImperial, classes } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.valueDisplay}>{ppf} {isImperial ? 'ppf' : 'ppm'}</div>
        {!EXPORT &&
          <div className={classes.controls}>
            <span>
              <FontAwesomeIcon
                icon='arrow-up'
                className={classes.increaseDistance}
                onMouseDown={this.startUpdateDistanceSaga.bind(this, true)} />
              <FontAwesomeIcon
                icon='arrow-down'
                className={classes.decreaseDistance}
                onMouseDown={this.startUpdateDistanceSaga.bind(this, false)}
              />
            </span>
          </div>
        }
        <div className={classes.valueDisplay}>
          {distance} {isImperial ? 'ft ' : 'm '}
        </div>
        <div className={classes.distanceAway}>Away</div>
        <div className={classes.warning}>
          <span className={classes.reallyBold}>Warning</span> results may vary depending on light and camera
        </div>
      </div>
    )
  }
}

export default connect(null, { updateDistanceOnIntervalAction, clearUpdateDistanceIntervalAction })(injectSheet(style)(PpfPreviewControls))



// WEBPACK FOOTER //
// ./src/components/PpfPreview/PpfPreviewControls/index.js